import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'; // Import useDispatch
import { addUser, updateUsers, editUser } from '../../redux/action'; // Import the addUser and updateUsers actions
import "./UserForm.css"

function UserForm({ roles, showForm }) { // No longer needs onSubmit prop as it dispatches directly
    const edit = useSelector((state) => state?.admin?.edit)
    const userSaving = useSelector((state) => Boolean(state?.admin?.userSaving));
    //const e = edit?.id ? edit : { name: '', email: '', role: roles.length > 0 ? roles[0] : '', phone: '' };
    const e = edit?.userId ? edit : { userId: 0, name: '', email: '', roleId: roles.length > 0 ? roles[0]?.value : '', phone: '' };
    const restaurantOrBranchId = '';
    const userId = 0;
    const [name, setName] = useState(e.name);
    const [email, setEmail] = useState(e.email);
    const [phone, setTel] = useState(e.phone);
    // const [password, setPassword] = useState('');
    const [roleId, setRole] = useState(e.roleId);
    const [errors, setErrors] = useState({});
    const submitLock = useRef(false);

    useEffect(() => {
        if (!userSaving) submitLock.current = false;
    }, [userSaving]);

    const dispatch = useDispatch(); // Initialize useDispatch hook

    const validateForm = () => {
        const newErrors = {};
        if (!name.trim()) newErrors.name = 'Name is required';
        if (!phone.trim()) newErrors.phone = 'Phone Number is required';
        else if (phone.length !== 10) newErrors.phone = 'Phone Number address is invalid';
        if (!email.trim()) newErrors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(email)) newErrors.email = 'Email address is invalid';
        // if (!password.trim()) newErrors.password = 'Password is required';
        // else if (password.length < 6) newErrors.password = 'Password must be at least 6 characters';
        if (!roleId) newErrors.roleId = 'Role is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (userSaving || submitLock.current) return;
        if (validateForm()) {
            submitLock.current = true;
            const userData = { restaurantOrBranchId, name, email, phone, roleId, userId }; // password removed as it's should not be used in the form
            // In a real app, you'd send this to your backend, then
            // if successful, dispatch addUser with the data (potentially including a backend-generated ID).
            // Dispatch the addUser action to update the Redux store
            if (edit?.userId) {
                userData.userId = edit.userId;
                dispatch(updateUsers(userData));
                // dispatch(editUser({}));
            } else {
                dispatch(addUser(userData));
                //showForm(false);
            }

            // Clear form fields af ter submission
            setName('');
            setEmail('');
            setTel('');
            // setPassword('');
            setRole(roles.length > 0 ? roles[0].value : '');
            showForm(false);
            setErrors({});
        }
    };

    return (
        <form id="user-form" onSubmit={handleSubmit} style={styles.form}>
            <div style={styles.formGroup}>
                <label htmlFor="name" style={styles.label}>Name:</label>
                <input
                    type="text"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    style={styles.input}
                />
                {errors.name && <p style={styles.errorText}>{errors.name}</p>}
            </div>

            <div style={styles.formGroup}>
                <label htmlFor="tel" style={styles.label}>Phone Number:</label>
                <input
                    type="phone"
                    id="tel"
                    value={phone}
                    onChange={(e) => setTel(e.target.value.replace(/[^0-9]/g, '').slice(0, 10))}
                    // todo: remove zero(s) at start 
                    style={styles.input}
                />
                {errors.phone && <p style={styles.errorText}>{errors.phone}</p>}
            </div>

            <div style={styles.formGroup}>
                <label htmlFor="email" style={styles.label}>Email:</label>
                <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={styles.input}
                />
                {errors.email && <p style={styles.errorText}>{errors.email}</p>}
            </div>

            {/* <div style={styles.formGroup}>
                <label htmlFor="password" style={styles.label}>Password:</label>
                <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={styles.input}
                />
                {errors.password && <p style={styles.errorText}>{errors.password}</p>}
            </div> */}

            <div style={styles.formGroup}>
                <label htmlFor="role" style={styles.label}>Role:</label>
                <select
                    id="role"
                    value={roleId}
                    onChange={(e) => setRole(e.target.value)}
                    style={styles.select}
                >
                    <option value="">---Select Role---</option>
                    {roles.map((r) => (
                        <option key={r.value} value={r.value}>{r.Key.charAt(0).toUpperCase() + r.Key.slice(1)}</option>
                    ))}
                </select>
                {errors.roleId && <p style={styles.errorText}>{errors.roleId}</p>}
            </div>

        </form>
    );
}

const styles = {
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formGroup: {
        marginBottom: '10px',
        textAlign: 'left',
    },
    label: {
        display: 'block',
        marginBottom: '5px',
        fontWeight: 'bold',
        color: '#333',
    },
    input: {
        width: '100%',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxSizing: 'border-box',
    },
    select: {
        width: '100%',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxSizing: 'border-box',
        backgroundColor: '#fff',
    },
    button: {
        padding: '12px 20px',
        backgroundColor: '#0f766e',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 'bold',
        transition: 'background-color 0.2s ease-in-out',
    },
    errorText: {
        color: 'red',
        fontSize: '0.85em',
        marginTop: '5px',
    },
};

export default UserForm;
